import { render, staticRenderFns } from "./setorgmodalorg.vue?vue&type=template&id=12e50f2b&scoped=true&"
import script from "./setorgmodalorg.vue?vue&type=script&lang=js&"
export * from "./setorgmodalorg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e50f2b",
  null
  
)

export default component.exports